import { Type } from '@sinclair/typebox';
import { BaseTxSchema } from './base-tx.js';
export const PoolMigrateFields = {
    operation: Type.Literal('poolMigrate'),
    targetProgram: Type.String(),
    targetPool: Type.String(),
};
export const PoolMigrateTxSchema = Type.Object({
    ...BaseTxSchema.properties,
    ...PoolMigrateFields,
});
//# sourceMappingURL=pool-migrate-tx.js.map